{
  "addAddress": "Ajouter une adresse",
  "addContactData": "Ajouter des données de contact",
  "additionalId": "Numéro d'article",
  "additionalStockInfos": "Informations supplémentaires sur le stock",
  "additionalTax": "plus{0} de TVA",
  "addProducts": "Ajouter des produits",
  "addProductToCollection": "Ajouter un produit à une collection",
  "addProductToComparison": "Ajouter le produit à la comparaison des produits",
  "addProductToQuote": "Ajouter un produit à une demande",
  "address": {
    "addition": "Ligne d'adresse supplémentaire",
    "city": "Ville",
    "clientNumber": "Numéro de client",
    "companyName": "Nom et forme juridique",
    "country": "Pays",
    "defaultBillingAddress": "Adresse de facturation par défaut",
    "defaultDeliveryAddress": "Adresse de livraison par défaut",
    "details": "Détails",
    "email": "Courriel ",
    "phone": "Téléphone",
    "postBox": "Boîte postale",
    "primaryAddress": "Adresse principale",
    "street": "Rue",
    "url": "URL",
    "website": "Site web",
    "zipCode": "Code postal",
    "zipCodeLong": "Code postal"
  },
  "addresses": "Adresses",
  "addToCart": "Ajouter au panier",
  "archiveAll": "Tout archiver",
  "availability": "Disponibilité",
  "b2bCommerPowered": "Powered by ITscope B2B Commerce",
  "backToPlatform": "Retour à ITscope",
  "billingAddress": "Adresse de facturation",
  "cancel": "Annuler",
  "cart": {
    "optimizationFailed": "L'optimisation du panier a échoué",
    "optimizationUnavailable": "Impossible d'exécuter l'optimisation du panier car il y a trop de positions dans le panier",
    "removeAll": "Vider le panier",
    "removeAllError": "Le panier n'a pas été vidé",
    "removeAllSuccess": "Le panier a été vidé avec succès"
  },
  "cartOutdated": {
    "description": "La commande n'a pas pu être envoyée parce que le panier n'est plus à jour. Veuillez recharger le panier et effectuer à nouveau la commande.",
    "title": "Le panier n'est plus à jour"
  },
  "cartPositionComment": "Remarques sur les articles",
  "categories": "Catégories",
  "changed": "Modifié",
  "changePassword": "Modifier le mot de passe",
  "charger": {
    "charger": "Chargeur inclus",
    "chargerIncludedTooltip": "Le chargeur est inclus avec ce produit.",
    "chargerNotIncludedHint": "Les chargeurs avec les compatibilités de charge suivantes peuvent être utilisés avec ce produit.",
    "chargerNotIncludedTooltip": "Le chargeur n’est pas inclus avec ce produit.",
    "noCharger": "Chargeur non inclus"
  },
  "checkEmail": "Vérifier l'e-mail",
  "checkoutExpiredDialog": {
    "buttonCaption": "Retour à la caisse",
    "description": "Votre commande attend",
    "title": "Vous êtes toujours là ?"
  },
  "chooseAddress": "Choisir l'adresse",
  "clientNumber": "Numéro de client",
  "closeErrorOrders": "Fermer la colonne contenant les commandes erronées",
  "closeFilter": "Fermez le filtre",
  "closeMessage": "Fermer le message",
  "closeQuoteActivity": "Fermer les activités",
  "collapseAccessoryCategory": "Réduire la catégorie d'accessoires « {0} ».",
  "collapseDescription": "Réduire la description « {0} ».",
  "collection": {
    "addAttachment": "Ajouter une pièce jointe",
    "addCollection": "Nouvelle collection",
    "addedToCartFailure": "Collection n'a pas pu être ajoutée au panier",
    "addedToCartPartialSuccess": "Certains articles n'ont pas pu être ajoutés au panier",
    "addedToCartSuccess": "Ajouté la collection au panier",
    "addProductToExistingCollection": "Ajouter un produit à une collection existante :",
    "addProductToNewCollection": "ou créer une nouvelle collection :",
    "addToCart": "Ajouter au panier",
    "assignee": "Employé responsable",
    "collections": "Collections",
    "collectProduct": "Collecter le produit",
    "data": "Dates",
    "deleteAction": "Supprimer collection",
    "deleteDialog": "Êtes-vous sûr de vouloir supprimer cette collection ?",
    "deletedMessage": "La collection a été retirée",
    "duplicate": "Duplicate",
    "editTitle": "Changer le titre de la collection",
    "emailSent": "La collection a été envoyée avec succès par e-mail.",
    "emptyCollection": "Aucun produit dans cette collection",
    "lastModified": "Dernière modification",
    "noCollectionAvailable": "Aucune collection disponible",
    "productAlreadyInCollection": "Produit déjà dans la collection",
    "sendEmail": "Partager par e-mail",
    "shareCollection": "Partager la collection \"{0}\" par e-mail",
    "subject": "Sujet",
    "success": {
      "itemRemoved": "Produit retiré avec succès"
    }
  },
  "common": {
    "archive": "Archiver",
    "archived": "Archivé",
    "comment": "Commentaire",
    "commentPlaceholder": "Ajouter un commentaire ici...",
    "comments": "Commentaires",
    "dearchive": "Déarchiver",
    "error": {
      "changeQuantity": "La quantité n'a pas pu être modifiée",
      "removeItem": "L'élément n'a pas pu être supprimé",
      "updateAssignee": "L'employé responsable n'a pas pu être changé",
      "updateComment": "Le commentaire n'a pas pu être mis à jour",
      "updateName": "Le titre de la collection n'a pas pu être mis à jour"
    },
    "sellerComment": "Commentaire pour le vendeur"
  },
  "company": {
    "deleteEmployee": "Retirer l'employé",
    "employee": "Employé",
    "employeeDeleted": "L'employé a été retiré",
    "employees": "Employés"
  },
  "companyData": "Données de la société",
  "companyRegistration": "Il n'existe pas encore de société pour l'adresse e-mail indiquée. Veuillez remplir le formulaire ci-dessous pour demander un accès.",
  "condition": {
    "B_STOCK": "Stock B",
    "BUILD_TO_ORDER": "Construire sur commande",
    "BULK": "Bulk",
    "DEMONSTRATION_MODEL": "Modèle de démonstration",
    "FACTORY_REFURBISHED": "Remis à neuf en usine",
    "NEW": "Nouveau",
    "NEWPULL": "Pièce de rechange d'un nouvel appareil",
    "NOT_FOR_RESALE": "Pas pour la revente",
    "REFURBISHED": "Remis à neuf",
    "RMA_WARE": "RMA",
    "USED": "Utilisé",
    "USEDPULL": "Pièce détachée d'un appareil usagé"
  },
  "conditionTooltip": {
    "conditionLabel": "Etat",
    "monthsWarranty": "mois de garantie"
  },
  "contactData": {
    "contactData": "Coordonnées",
    "email": "Courrier électronique",
    "firstName": "Prénom",
    "lastName": "Nom de famille"
  },
  "contactTitles": {
    "diverse": "Mx",
    "female": "Mme",
    "male": "M.",
    "unspecified": "non spécifié"
  },
  "continue": "Continuer",
  "copy": "Copie",
  "coreData": "Données de base",
  "costs": "Coûts",
  "create": "Créer",
  "created": "Créé",
  "createdDate": "Date de création",
  "cto": {
    "appleCtoFinder": "Apple CTO Finder",
    "configure": "Configurer {0}",
    "customiseConfiguration": "Personnaliser la configuration",
    "foundProduct": "Produit trouvé",
    "noProductFound": "Aucun produit n'a pu être trouvé pour cette configuration",
    "selectBaseModel": "Sélectionnez le modèle de base",
    "selectedConfiguration": "Configuration sélectionnée",
    "selectProductClass": "Sélectionnez la classe de produits Apple"
  },
  "customerOrderId": "Numéro de commande du client",
  "datasheet": "Fiche technique",
  "datasheetError": "La fiche technique n'a pas pu être chargée",
  "datasheetManufacturer": "Fiche technique du fabricant",
  "datasheetNotFound": "Aucune fiche de données disponible pour ce produit",
  "datasheetPdf": "Fiche technique (PDF)",
  "decline": "Déclin",
  "declineReason": "Raison du déclin",
  "delete": "Supprimer",
  "deleteAddress": "Supprimer l'adresse",
  "deleteAddressDialog": "Êtes-vous sûr de vouloir supprimer cette adresse ?",
  "deleteContactData": "Supprimer les données de contact",
  "deliveryTracking": {
    "deliveryTracking": "Informations sur l'expédition",
    "trackPackage": "Paquet de pistes"
  },
  "departments": {
    "Accounting": "Comptabilité",
    "Extern": "Externe",
    "IT": "IT",
    "Management": "Management",
    "Marketing": "Marketing",
    "Other": "Autre",
    "Purchasing": "Achats",
    "RegistrationPending": "Enregistrement en attente",
    "Sales": "Ventes",
    "ServiceSupport": "Service/Support"
  },
  "discount": "- {0} de réduction",
  "documentError": "Impossible de charger le document",
  "downloadAllOrderDocumentsAsPdf": "Télécharger tous les documents de commande au format PDF",
  "downloadOrderDocumentAsPdf": "Télécharger le document de commande « {0} » au format PDF",
  "ean": "EAN",
  "editAddress": "Modifier l'adresse",
  "editCollectionAssignee": "Changer le employé responsable",
  "editContactData": "Modifier les données de contact",
  "ellipsis": "...",
  "emailAddress": "Adresse électronique",
  "emailForRegistration": "Veuillez indiquer une adresse e-mail avec laquelle vous souhaitez vous enregistrer.",
  "emailRequestPriceHint": "Le mail suivant sera envoyé au exploitant du magasin en ligne (ceci n'est qu'un aperçu du texte):",
  "emptyCart": "Il n'y a pas de produit dans le panier",
  "epeat": "Certifié EPEAT",
  "epeatTooltip": {
    "description1": "Label écologique international pour les produits informatiques.",
    "description2": "Évalue, entre autres, l'efficacité énergétique, la recyclabilité et le choix des matériaux.",
    "description3": "Les niveaux : Bronze, Argent, Or - plus le niveau est élevé, plus le produit est respectueux de l'environnement.",
    "title": "Label EPEAT"
  },
  "eprel": {
    "energyEfficiency": "Étiquette énergie",
    "energyEfficiencyAndProductDatasheet": "Informations sur l’étiquette énergie",
    "energyEfficiencyInformationSheet": "Fiche technique"
  },
  "error": {
    "addressCreated": "L'adresse n'a pas pu être créée",
    "addressDeleted": "L'adresse n'a pas pu être supprimée",
    "addressesNotFound": "Impossible de charger les adresses",
    "addressPropertyInvalid": "Le champ d'adresse {propertyName} n'est pas valide.",
    "addressSaved": "L'adresse n'a pas pu être enregistrée",
    "alreadyInvited": "Le collègue {0} est déjà invité",
    "alreadyRegistered": "Le collègue {0} est déjà inscrit",
    "cartNotFound": "Le panier n'a pas pu être chargé",
    "categoriesNotFound": "Impossible de charger les catégories",
    "changePassword": "Quelque chose s'est mal passé en essayant de changer le mot de passe",
    "changeQuantity": "La quantité dans le panier n'a pas pu être modifiée",
    "collectionNotFound": "La collection n'a pas pu être chargée",
    "documentsNotFound": "Impossible de charger les documents",
    "emailAlreadyRegistered": "L'email est déjà enregistré.",
    "emptyField": "Le champ {0} doit avoir une valeur valide",
    "essentialShopActivationRequested": "Une erreur s'est produite lors de l'envoi de la demande",
    "fileTooLarge": "La taille du fichier est trop grande",
    "genericError": "Quelque chose a mal tourné",
    "identifiersNotFound": "Les identifiants n'ont pas pu être chargés",
    "invalidCharacters": "Seules les lettres, les chiffres et les caractères _ / . # +, ainsi que les parenthèses et les crochets, sont autorisés (minimum de 3 caractères)",
    "invalidEmail": "Adresse électronique non valide",
    "invalidEmails": "Les adresses postales suivantes sont valides : {0}",
    "invalidName": "Nom non valide",
    "invalidNegativeNumber": "Seuls les nombres positifs sont autorisés",
    "invalidNumber": "Numéro non valide",
    "invalidUrl": "Url non valide",
    "invalidWhitespace": "Pas d'espaces en début, en fin ou multiples consécutifs autorisés",
    "invitation": "Quelque chose s'est mal passé en essayant d'envoyer l'invitation",
    "keywordTooShort": "Veuillez saisir un terme de recherche d'au moins 2 caractères",
    "mailBlacklisted": "Le domaine {0} n'a pas été mis sur la liste blanche. Contactez votre administrateur de portail..",
    "noAdmin": "Vous devez avoir des droits d'administrateur pour inviter des collègues",
    "noConsent": "Le consentement doit être signé",
    "oldPassword": "Mot de passe actuel invalide",
    "ordersNotFound": "Impossible de charger les commandes",
    "pageNotFound": "Page non trouvée",
    "passwordNotAllowedChar": "Le mot de passe contient un ou plusieurs caractères interdits.",
    "passwordRepeat": "Les valeurs des champs de mot de passe ne correspondent pas",
    "passwordRequirements": "Votre mot de passe ne répond pas aux exigences actuelles en matière de mot de passe.",
    "positiveDigit": "La valeur doit être positive",
    "productAdded": "Le produit n'a pas pu être ajouté au panier",
    "productAlreadyInComparison": "Le produit est déjà dans la comparaison",
    "productComparisonMaxNumber": "Un maximum de 3 produits peut être comparé",
    "productDeleted": "Le produit n'a pas pu être retiré du panier",
    "productNotAvailableBySupplier": "Ce fournisseur n'offre pas ce produit.",
    "productNotFound": "Le produit n'a pas pu être chargé",
    "productRequest": "Un problème est survenu lors de l'envoi de la demande",
    "productTypeIncorrectForComparison": "Seulement les produits de la même catégorie peuvent être comparés entre eux",
    "quoteForbidden": "Cette offre n'est pas encore active",
    "quoteNotFound": "Impossible de charger l'offre",
    "quotesNotFound": "Impossible de charger les offres",
    "refresh": "D'autres utilisateurs ont apporté des modifications. Rafraîchissez la page.",
    "registration": "Quelque chose s'est mal passé en essayant d'envoyer l'enregistrement",
    "registrationTokenError": "Le lien pour enregistrer un nouvel utilisateur semble être défectueux. Veuillez en demander un nouveau.",
    "requiredField": "Champ obligatoire",
    "resetPassword": "Quelque chose s'est mal passé en essayant de réinitialiser le mot de passe",
    "resetTokenError": "Le lien pour réinitialiser le mot de passe n'est plus valide. Veuillez en demander un nouveau.",
    "serverError": "Erreur de serveur",
    "shortPassword": "Doit comporter au moins 8 caractères",
    "startPage": "La page de démarrage n'a pas pu être chargée",
    "timeout": "La demande a expiré",
    "tooManyRequests": "Trop de requêtes. Réessayez plus tard.",
    "unknownError": "Une erreur inconnue s'est produite pendant la demande ({0}).",
    "unknownLoginError": "Une erreur inconnue s'est produite lors de l'ouverture de la session.",
    "unsupportedMediaType": "Le type de fichier n'est pas supporté",
    "updateComment": "Le commentaire en texte libre n'a pas pu être mis à jour",
    "userDeactivated": "L'utilisateur spécifié est désactivé, la connexion n'est actuellement pas possible.",
    "validDigit": "La valeur doit être un nombre entier valide",
    "wrongCredentials": "Votre adresse électronique ou votre mot de passe est incorrect."
  },
  "errorId": "ID d'erreur",
  "errorPageHeadline": "Quelque chose a mal tourné.",
  "errorPageOops": "Ooops",
  "errorPageQuoteNotAvailableSorry": "Veuillez réessayer plus tard.",
  "errorPageStart": "Aller à la page de démarrage",
  "essentialShopDeactivated": {
    "descriptionEnd": "Contactez votre partenaire pour obtenir l'accès.",
    "descriptionPoint1": "de consulter l'historique de vos offres",
    "descriptionPoint2": "d'envoyer des demandes d'offres directement à votre partenaire",
    "descriptionPoint3": "d'accéder à une gamme de 50 000 produits informatiques avec filtre et fonction de recherche",
    "descriptionPoint4": "de passer commande facilement et directement",
    "descriptionStart": "Dans la boutique Essential, vous avez la possibilité :",
    "descriptionTitle": "La boutique Essential de votre partenaire est actuellement désactivée.",
    "pageTitle": "Boutique Essential désactivée",
    "requestActivation": "Demander l'activation",
    "requestActivationHint": "Veuillez indiquer votre adresse e-mail afin que votre partenaire puisse vous contacter."
  },
  "excludingVatHint": "Tous les prix sont hors TVA de{0}",
  "excludingVatShort": "excl.{0} de TVA",
  "expandAccessoryCategory": "Déplier la catégorie d'accessoires « {0} ».",
  "expandDescription": "Déplier la description « {0} ».",
  "featureAd": {
    "comparison": {
      "description": "Vous pouvez ajouter des produits à la comparaison via la page des produits",
      "shortDescription": "Vous pouvez dès à présent comparer les produits.",
      "title": "Comparaison des produits"
    },
    "descriptionEnd": "Nous en serons informés et vous présenterons une offre directement commandable ici même dans votre portail.",
    "descriptionStart": "C'est ainsi que vous demandez une offre pour une collection de produits:",
    "NEW": "NOUVEAU",
    "requestFunction": "Demandez des offres",
    "step1": "Cliquez sur \"Créer une demande\"",
    "step2": "Ajouter des produits",
    "step3": "Envoyer la demande",
    "tryItOut": "Essayez-le !"
  },
  "filter": {
    "filter": "Filtre",
    "filters": "Filtres",
    "noFiltersSelected": "Aucun filtre sélectionné",
    "productFilters": "Caractéristiques",
    "productType": "Type de produit",
    "resetFilter": "Réinitialiser le filtre"
  },
  "finishRegistration": "Fin de l'enregistrement",
  "forgotPassword": "Mot de passe oublié ?",
  "grading": {
    "A": "Comme neuf",
    "B": "Très bon",
    "C": "Bon",
    "D": "Acceptable"
  },
  "hideCategories": "Cacher catégories",
  "hideCategory": "Pliez la catégorie",
  "hidePassword": "Masquer le mot de passe",
  "impersonateMode": "Vue du client - Vous êtes connecté en tant qu'administrateur de la boutique B2B dans {0}",
  "impersonateModeEssentialShop": "Vue client – Connecté en tant que gérant de boutique",
  "includingVat": "incl.{0} de TVA",
  "includingVatHint": "Tous les prix incluent{0} de TVA",
  "includingVatShort": "incl.{0} de TVA",
  "invitationHint": "Vous pouvez ici inviter d'autres collègues sur votre portail. Veuillez saisir les adresses électroniques auxquelles vous souhaitez envoyer une invitation et séparez-les par un point-virgule ou un espace.",
  "inviteColleagues": "Inviter des collègues",
  "languages": {
    "de": "Allemand",
    "en": "Anglais",
    "es": "Espagnol",
    "fr": "Français",
    "it": "Italien",
    "nl": "Néerlandais",
    "pl": "Polonais"
  },
  "legalInfo": "Informations légales",
  "less": "moins",
  "localization": "Localisation",
  "login": "Connexion",
  "login_sso": "Se connecter avec l'authentification unique (SSO)",
  "loginQuotesPortal": "Connexion au portail d'offres",
  "manufacturerId": "ID du fabricant",
  "max": "Max.",
  "maxLength": "Longueur maximale des caractères de {0} atteinte",
  "mobex360Info": "Si le crédit mobex360 est insuffisant, la commande sera automatiquement facturée !",
  "mobexPaymentMethod": {
    "CREDIT": "Avec le crédit mobex360",
    "INVOICE": "Par facture"
  },
  "more": "plus",
  "moreInfoEpeatTooltip": "Plus d'informations sur le label EPEAT",
  "moreUppercase": "Plus de",
  "myCompany": "Mon entreprise",
  "myProfile": "Mon profil",
  "name": "Nom",
  "newPassword": "Nouveau mot de passe",
  "newPasswordRepeat": "Confirmer le nouveau mot de passe",
  "no": "Non",
  "noAppleProductsAvailable": "Aucun produit Apple disponible",
  "noCategoriesFound": "Aucune catégorie disponible",
  "noCollectionsFound": "Aucune collection disponible",
  "noDataAvailable": "Aucune donnée disponible",
  "noEntries": "Aucune entrée disponible",
  "noImageAvailable": "Aucune image disponible",
  "noItemsInQuote": "Cette offre ne contient pas de positions",
  "noOrderDocumentsFound": "Aucun document disponible",
  "noOrdersFound": "Aucune commande disponible",
  "noProductsFound": "Aucun produit trouvé",
  "noSupplier": "Non attribué",
  "nullPriceLabel": "-.--",
  "oldPassword": "Mot de passe actuel",
  "onlyWholePositiveNumbers": "Seuls les nombres entiers positifs sont autorisés",
  "open": "Ouvrir",
  "openCart": "Ouvrir le panier",
  "openCategory": "Pliez la catégorie",
  "openFilter": "Ouvrir le filtre",
  "openMenu": "Ouvrir menu",
  "openProductComparison": "Ouvrir la comparaison des produits",
  "openProductPage": "Ouvrir la page produit",
  "openTopiCheckout": "Ouvrir le topi-Checkout",
  "optimizationStrategyType": {
    "MANUAL": "Manuellement",
    "MINPRICE": "Meilleur prix",
    "MINSUPPLIERS": "Sources minimales"
  },
  "order": {
    "addedToCartFailure": "La commande n'a pas pu être ajoutée au panier",
    "addedToCartPartialSuccess": "Certains articles n'ont pas pu être ajoutés au panier",
    "addedToCartSuccess": "Ajouté la commande au panier",
    "customerOrderIdMissing": "Un identifiant de commande client doit être donné.",
    "declineOrder": "Ordre de déclassement",
    "deleteDialog": "Êtes-vous sûr de vouloir supprimer cette commande ?",
    "deleteLastItemDialog": "Attention : En supprimant le dernier élément de la commande, la commande complète sera également supprimée. Voulez-vous continuer ?",
    "deleteOrder": "Supprimer la commande",
    "deleteOrderItem": "Supprimer la position de l'ordre",
    "details": "Commandez",
    "documents": "Documents",
    "editAddressHint": "Les changements d'adresse ne concernent que cette commande.",
    "exclTotalTax": "hors TVA de{0} {1}",
    "goToOrder": "Continuer à commander",
    "inclTotalTax": "{0} TVA incluse {1}",
    "inEuTotalTax": "plus{0} TVA {1}",
    "moreInfosLabel": "Plus de détails",
    "netDiscount": "Remise supplémentaire",
    "noApprover": "Il semble qu'aucun approbateur ne soit éligible pour cette commande. Veuillez contacter l'opérateur de votre portail.",
    "noOrderRightHint": "Vous n'avez pas la permission d'exécuter l'ordre.",
    "order": "Commandez",
    "orderAlreadyBeingProcessed": "La commande est déjà en cours de traitement. Veuillez attendre quelques minutes.",
    "orderDate": "Date de la commande",
    "orderLimitApprovalHint": "Les personnes suivantes seront informées par e-mail de votre demande d'approbation de commande. Dès que l'approbation de la commande aura été confirmée ou rejetée, vous en serez informé par e-mail.",
    "orderLimitHint": "L'ordre d'une valeur de {0} a dépassé votre limite d'ordre actuelle de {1}. Veuillez demander une approbation de l'ordre.",
    "orderNotFound": "La commande n'a pas pu être chargée",
    "orderNumber": "Numéro de commande",
    "orderNumberDuplicate": "Le numéro de commande {0} a déjà été utilisé pour une commande. Veuillez essayer avec un autre numéro de commande.",
    "orderNumberGeneratedAfterOrder": "Est généré après l'ordre",
    "orderNumberMissing": "Un numéro de commande doit être indiqué.",
    "orderNumbers": "Numéros de commande",
    "orderRequested": "Demande envoyée",
    "orders": "Commandes",
    "orderSent": "Votre commande a été transmise et est en cours de traitement.",
    "orderTimeoutError": "Aucune réponse de commande reçue. Veuillez recharger la page.",
    "partialShipmentAllowed": "Envoi partiel autorisé",
    "paymentMethodMissing": "Un mode de facturation doit être indiqué.",
    "quantitySurcharge": "Supplément pour commande minimale",
    "requestOrder": "Demander",
    "selectAddressHint": "Seules les adresses que vous avez créées peuvent être utilisées.",
    "sendOrder": "Commande contraignante",
    "shippingAddress": "Adresse de livraison",
    "shippingCosts": "Expédition",
    "shippingCostsGross": "Frais d'expédition bruts",
    "shippingCostsNet": "Frais d'expédition nets",
    "subTotal": "Sous-total",
    "toOrder": "Passer la commande",
    "toOrderFrom": "Commandez à partir de {0}",
    "totalCostsGross": "Montant total brut",
    "totalCostsNet": "Montant total net"
  },
  "orderApproval": {
    "approvableOrders": "Commandes sans approbation",
    "approvedInformation": "La commande a été approuvée par {0} le {1}.",
    "declinedInformation": "La commande a été refusée par {0} le {1}.",
    "orderDeclined": "Commande refusée avec succès",
    "pendingInformation": "Le {0}, une autorisation de commande a été demandée par {1} aux personnes suivantes :",
    "pendingInformationApprover": "Pour cette commande, une autorisation de commande vous a été transmise le {0}.",
    "pendingInformationRequester": "Le {0}, vous avez transmis une autorisation de commande aux personnes suivantes :"
  },
  "orderBy": "Commande passée auprès de {0}",
  "ordered": "Commandé",
  "orderLimits": {
    "activateOrderLimits": "Activer les limites d'ordre",
    "default": "Défaut",
    "defaultApprovers": "Approbateur par défaut",
    "defaultApproversEmpty": "Aucun approbateur par défaut sélectionné",
    "defaultApproversUsed": "Les approbateurs par défaut sont utilisés",
    "defaultLimit": "Limite générale",
    "defaultLimitDescription": "Cette limite de commande est la valeur par défaut pour tous les employés et est remplacée par des limites de commande spécifiques aux employés.",
    "description": "En assignant des limites, les employés ne peuvent commander que jusqu'à une valeur donnée. Les commandes qui dépassent cette valeur doivent être demandées à un collègue disposant de droits d'approbation.",
    "editOrderLimitUser": "Modifier la limite de commande de l'utilisateur « {0} ».",
    "editStandardApprovers": "Modifier les approbateurs par défaut",
    "individual": "Individuel",
    "noEmployeeFound": "Aucun employé trouvé",
    "noEmployeesFound": "Aucun employé disponible",
    "orderApproval": "Approbation de la commande",
    "orderApprover": "Approbation de la commande",
    "orderLimit": "Limite de commande",
    "orderRight": "Droit de commande",
    "unlimited": "Illimité"
  },
  "orderOutdated": {
    "description": "La commande n'a pas été envoyée car elle est périmée. Veuillez recharger la commande et l'exécuter à nouveau.",
    "title": "La commande est périmée"
  },
  "orderStatus": {
    "ADVISED": "Dépêché",
    "ARRIVED": "Commande reçue",
    "ARRIVED_WARNING": "Reçu avec un avertissement",
    "BLOCKED": "Bloqué",
    "BLOCKED_BYLIMIT": "Bloqué",
    "CANCELED": "Annulé",
    "ERROR": "Erreur",
    "IN_TOPI_CHECKOUT": "Dans le topi-checkout",
    "INVOICED": "Facturé",
    "ORDERED_ELSEWHERE": "Commandé ailleurs",
    "PARTIALLY_ADVISED": "Partiellement expédié",
    "PARTIALLY_INVOICED": "Partiellement facturé",
    "PARTIALLY_PROCESSING": "Partiellement confirmé",
    "PAYMENT_AWAITING": "En attente de paiement",
    "PAYMENT_SUCCESSFUL": "Paiement réussi",
    "PENDING_TOPI_APPROVAL": "Approbation en attente",
    "PORTAL_APPROVAL_DENIED": "Rejeté",
    "PREPARING": "En attente",
    "PROCESSING": "Commande confirmée",
    "REJECTED": "Rejeté",
    "SENDING_ERROR": "Erreur de transmission",
    "SENT": "Transmis",
    "TOPI_DECLINED": "Rejeté par topi",
    "TOPI_EXPIRED": "Offre topi expirée",
    "TRANSMITTING": "Transmettre"
  },
  "partsList": "Liste des pièces",
  "password": "Mot de passe",
  "passwordRepeat": "Répéter le mot de passe",
  "paymentMethod": "Mode de paiement",
  "PDF": "PDF",
  "per": "par",
  "personalData": "Données personnelles",
  "pleaseSelect": "Veuillez sélectionner...",
  "portal": "Portail",
  "portalPaused": "Portail en pause",
  "portalPausedDescription": "Ce portail est actuellement en pause, la connexion n'est donc pas possible. Si vous avez des questions, veuillez contacter le propriétaire de votre portail.",
  "positions": "Aucune position | {n} position | {n} positions",
  "price": {
    "graduatedPrices": "Prix échelonnés",
    "manufacturerSuggestedRetailPrice": "PDSF",
    "packaging": "Unité d'emballage",
    "packaging_contentUnit": "Content unit:",
    "packaging_contentUnit_label": "Unité de l'article dans une unité de commande (par exemple, \"pièce\" dans l'unité de commande \"pack\").",
    "packaging_intervalQuantity": "Intervalle de quantité :",
    "packaging_intervalQuantity_label": "Quantité qui indique l'intervalle dans lequel l'article peut être commandé (en unités de commande).",
    "packaging_minQuantity": "Quantité minimale de commande :",
    "packaging_minQuantity_label": "La plus petite quantité de stock qui doit être commandée.",
    "packaging_numberContentUnitPerOrderUnit": " Quantité d'emballage :",
    "packaging_numberContentUnitPerOrderUnit_label": "Le nombre de sous-unités contenues dans l'unité de l'article.",
    "packaging_orderUnit": "Unité de commande :",
    "packaging_orderUnit_label": "Unité dans laquelle le produit peut être commandé ; seuls des multiples de l'unité d'article peuvent être commandés.",
    "packaging_priceQuantity": "Quantité de prix :",
    "packaging_priceQuantity_label": "Un multiple de l'unité de commande, qui indique la quantité à laquelle les prix se réfèrent.",
    "packaging_supplierPackingQuantity": "Quantité d'emballage du fournisseur :",
    "packaging_supplierPackingQuantity_label": " Quantité d'emballage du fournisseur (en unités de commande).",
    "price": "Prix",
    "priceBillingPeriod": "par {0}",
    "priceBillingPeriodShort": "p. {0}",
    "priceOnRequest": "O/R",
    "pricePurchase": "Prix d'achat",
    "priceSubscriptionPeriod": "{0} période du contrat",
    "priceVatStar": "*",
    "startingAt": "à partir de {0}"
  },
  "priceRange": {
    "applyPriceRange": "Appliquer la fourchette de prix",
    "fromPriceRange": "A partir de {0} {1}",
    "fromToPriceRange": "{0} {2} - {1} {2}",
    "invalidPriceRange": "Fourchette de prix non valable",
    "priceRange": "Fourchette de prix",
    "priceRangeFrom": "Fourchette de",
    "priceRangeTo": "Fourchette à",
    "toPriceRange": "Jusqu'à {0} {1}"
  },
  "print": "Imprimer",
  "privacy": "Vie privée",
  "privacyConsent": "J'accepte que mes données soient traitées conformément à la politique de confidentialité.",
  "product": "Produit",
  "productAccessories": "Accessoires",
  "productComparison": {
    "highlightDifferences": "Souligner les différences",
    "noData": "Aucune donnée comparable n'a été trouvée pour les produits sélectionnés",
    "noMobileVersion": "La comparaison de produits n'est pas disponible dans l'affichage mobile",
    "noProducts": "Aucun produit dans la comparaison",
    "pageTitle": "Comparer les produits",
    "removeProduct": "Supprimer le produit de la comparaison"
  },
  "productDescription": "Description",
  "productId": "ID du produit",
  "productIdentifiers": "ID des produits",
  "productNoLongerAvailable": "Le produit n'est plus disponible",
  "products": "Produits",
  "productSort": {
    "AVAILABILITY": "Disponibilité",
    "CALC_PRICE_ASC": "Prix en hausse",
    "CALC_PRICE_DESC": "Prix en baisse",
    "NAME_ASC": "Nom du produit en ordre croissant",
    "NAME_DESC": "Nom du produit en ordre décroissant",
    "POPULARITY": "Popularité",
    "RELEVANCE": "Pertinence",
    "STOCK": "Niveau du stock"
  },
  "productStockInfo": {
    "nextDelivery": "Prochaine date de livraison selon le distributeur prévue le {0}.",
    "nextDeliveryB2B": "Date de livraison prévue pour le fournisseur en amont : {0}.",
    "noNextDelivery": "La date précise de livraison est inconnue.",
    "onStock": "{0} en stock",
    "onSupply": "{0} bientôt disponible",
    "unavailableMessage": "Ce produit n'est pas disponible."
  },
  "punchout": {
    "backToProcurement": "Retour à votre système",
    "backToProcurementCaption": "Retourner dans votre système sans commande | Reprendre une position dans votre système | Reprendre {n} positions dans votre système",
    "table": {
      "position": "ID",
      "price": "Prix",
      "quantity": "Qté",
      "sum": "Somme",
      "title": "Titre"
    }
  },
  "quantityFrom": "Quantité à partir de",
  "quoteOutdated": {
    "description": "La commande n'a pas été envoyée parce que l'offre est périmée. Veuillez recharger l'offre et exécuter à nouveau la commande.",
    "title": "L'offre est périmée"
  },
  "quotePreview": "Vous êtes dans l'aperçu de l'offre",
  "quoteRegistration": {
    "description": "En vous inscrivant dans votre Essential Shop personnelle, vous bénéficiez...",
    "products": "Accès à <b>50 000 produits informatiques</b>",
    "quoteDocument": "accès à tous les <b>documents pertinents de l'offre</b>",
    "quoteHistory": "<b>l'historique des offres</b> avec toutes les offres déjà reçues",
    "quoteRequest": "la possibilité d'envoyer des <b>demandes</b>"
  },
  "quoteRequest": {
    "cannotEditRequest": "Il n'y a plus de changement possible, la demande a déjà été envoyée.",
    "emptyRequest": "Aucun produit n'a encore été ajouté",
    "lineItemAdded": "L'article a été ajouté avec succès",
    "notInAssortment": "Actuellement pas dans l'assortiment",
    "requestAgain": "Demander à nouveau",
    "requestNotFound": "La demande d'offre n'a pas pu être trouvée",
    "sendRequest": "Envoyer la demande",
    "sentQuoteRequest": "La demande d'offre a été envoyée",
    "textLineItemAdd": "Ajouter un élément de texte",
    "textLineItemChangeError": "Le titre de la position du texte n'a pas pu être modifié"
  },
  "quotes": {
    "acceptQuote": "Accepter l'offre",
    "addProductToExistingQuote": "Ajouter un produit à la demande existante :",
    "addProductToNewQuote": "ou créer une nouvelle demande :",
    "author": "Auteur",
    "createRequest": "Créer une demande",
    "declineInformation": "L'offre a été refusé par {0} le {1}.",
    "declineQuote": "Décliner l'offre",
    "declineQuoteDialog": "Êtes-vous sûr de vouloir refuser cette offre ?",
    "deleteDescription": "Êtes-vous sûr(e) de vouloir supprimer cette demande ?",
    "deleteTitle": "Supprimer demande",
    "deselectOptionalItem": "Désélectionner la position optionnelle",
    "duplicateUserWarning": "Vous ne pouvez pas accepter cette offre car votre adresse e-mail a déjà été associée à une autre entreprise. Veuillez vous adresser au créateur de l'offre.",
    "editTitle": "Modifier le titre de la demande",
    "new": "Nouveau",
    "noLongerValid": "Cette offre a expiré le \"{0}\" et n'est plus valable.",
    "noOptionalPosition": "Pas de position optionnelle",
    "noQuoteEmptySpace": "Aucune offre disponible pour le moment",
    "noQuoteRequestsFound": "Aucune demande disponible",
    "noQuotesFound": "Aucune offre disponible",
    "quote": "Ofrre",
    "quoteRequested": "La demande a été créée avec succès",
    "quotes": "Offres",
    "request": "Request",
    "selectOptionalItem": "Sélectionner la position optionnelle",
    "showActivity": "Afficher les activités"
  },
  "quoteStatus": {
    "ACCEPTED": "Accepté",
    "DRAFT": "Projet",
    "NEGOTIATION": "En cours",
    "REJECTED": "Rejeté",
    "REQUESTED": "Demandé"
  },
  "readOnlyMode": "Vous êtes actuellement en mode lecture seule.",
  "realtimePrices": "Prix en temps réel",
  "realtimePricesLoaded": "Prix en temps réel chargés",
  "recipients": "Bénéficiaires",
  "refresh": "Recharger",
  "refreshPage": "Recharger la page",
  "register": "Registre",
  "registerCompany": "Enregistrer la société",
  "registration": "Inscription",
  "registrationDisabled": "Inscription désactivée",
  "registrationDisabledDescription": "Le gérant a désactivé l'inscription et la connexion à ce portail.",
  "registrationLinkSent": "Un e-mail contenant le lien d'enregistrement a été envoyé à votre adresse e-mail. Veuillez ouvrir le lien pour terminer l'enregistrement.",
  "registrationRequested": "La demande a été transmise à l'opérateur du portail. Vous recevrez une notification lorsque la demande aura été acceptée.",
  "removeDialog": "Êtes-vous sûr de vouloir supprimer cet employé ?",
  "removeProductFromCart": "Retirer le produit du panier",
  "removeProductFromCollection": "Supprimer le produit de la collection",
  "removeProductFromQuoteRequest": "Supprimer le produit de la demande",
  "requestPrice": "Demander le prix",
  "requestRegistration": "Demander l'accès",
  "resetPassword": "Réinitialiser le mot de passe",
  "rma": {
    "requested": "Demande de renvoi envoyée",
    "return": "Renvoi",
    "returned": "renvoyé",
    "returnReason": "Motif du renvoi",
    "selectedPositions": "Positions sélectionnées",
    "selectPositions": "Veuillez sélectionner les positions pour votre renvoi",
    "selectProductForReturn": "Choisir le produit à renvoyer",
    "selectReturnReason": "Choisir le motif"
  },
  "save": "Enregistrer",
  "saveAddress": "Sauvegarder l'adresse",
  "search": "Recherche",
  "searchAll": "Parcourir tout",
  "searchResults": "Recherche de \"{0}\" dans les produits",
  "send": "Envoyer",
  "sendInvitation": "Envoyer une invitation",
  "serialNumbers": {
    "copyAll": "Copier tout",
    "serialNumbers": "Numéros de série",
    "serialNumbersCopied": "Numéros de série copiés dans le presse-papiers"
  },
  "serverOffline": {
    "description": "Le portail est actuellement indisponible pour cause de maintenance. Veuillez réessayer plus tard.",
    "title": "Portail non disponible"
  },
  "shippingCostsShort": "Expédition",
  "shoppingCart": "Panier d'achat",
  "shortUrl": {
    "enterZipCode": "Pour ouvrir l'offre, veuillez saisir le code postal de votre adresse :",
    "enterZipCodeTitle": "Saisir le code postal",
    "error": "Oups ! Ce lien n'est pas valide !",
    "wrongZipCode": "Le code postal saisi n'est pas valide !"
  },
  "showCategories": "Afficher catégories",
  "showErrorOrders": "Afficher toutes les commandes avec un statut d'erreur",
  "showPassword": "Montrer le mot de passe",
  "signIn": "Connexion",
  "signOut": "Se déconnecter",
  "sortBy": "Trier par",
  "sortbyAsc": "Trier par ordre croissant de « {0} ».",
  "sortByDesc": "Trier par ordre décroissant de « {0} ».",
  "sources": "Sources d'approvisionnement",
  "status": "Statut",
  "stock": "Stock",
  "stockStatus": {
    "Available": "Disponible sur",
    "NotAvailable": "Non disponible",
    "OnOrder": "Basé sur les commandes",
    "OnStock": "En stock",
    "Ordered": "Bientôt disponible",
    "Unknown": "Inconnu",
    "Warehouse": "stock externe"
  },
  "stockStatusDescription": "Le statut du stock est « {0} ».",
  "subsidiaryMode": "Vue du client - Vous êtes connecté à {0}",
  "success": {
    "addedToCollection": "Le produit a été ajouté avec succès à la collection",
    "addedToCollectionLink": "Le produit a été ajouté avec succès à la collection \"{0}\" >>",
    "addedToComparison": "Produit ajouté à la comparaison",
    "addedToQuote": "Le produit a été ajouté avec succès à la demande",
    "addedToQuoteLink": "Le produit a été ajouté avec succès à la demande \"{0}\". >>",
    "addressCreated": "L'adresse a été créée",
    "addressDeleted": "L'adresse a été supprimée",
    "addressSaved": "L'adresse a été enregistrée",
    "cartRefreshed": "Panier mis à jour",
    "changeLanguage": "La langue a changé",
    "changePassword": "Le mot de passe a été modifié avec succès",
    "essentialShopActivationRequested": "La demande d'activation a été envoyée",
    "invitationSent": "Invitation envoyée avec succès",
    "orderArchived": "Commande archivée",
    "orderDearchived": "Commande désarchivée",
    "productAdded": "Le produit a été ajouté au panier",
    "productDeleted": "Le produit a été supprimé du panier",
    "productRequested": "Demande de produit envoyée",
    "quoteArchived": "Offre archivée",
    "quoteDearchived": "Offre desarchivée",
    "registrationComplete": "Inscription réussie",
    "removedFromComparison": "Le produit a été retiré de la comparaison",
    "resetPassword": "Un courriel a été envoyé à \"{0}\" s'il existe un compte d'utilisateur actif."
  },
  "supplier": "Fournisseur",
  "supplierPid": " Numéro de distributeur",
  "switchSubsidiary": "Changer d'entreprise",
  "switchSubsidiaryHint": "Vous pouvez vous connecter à d'autres entreprises",
  "technicalData": "Données techniques",
  "terms": "Conditions générales",
  "time": {
    "day": "jour",
    "hour": "heure",
    "minute": "minute",
    "month": "mois",
    "year": "année"
  },
  "title": "Titre",
  "to": "à",
  "today": "Aujourd'hui",
  "topiExpiredHint": "L'offre de topi a malheureusement expiré. Veuillez ajouter à nouveau les produits au panier à l'aide du menu en trois points, puis cliquer sur 'Continue to rental configuration'.",
  "transactionType": {
    "DELIVERY": "Bon de livraison",
    "INVOICE": "Facture pro forma",
    "ORDER": "Commande",
    "ORDERSTATUS": "Réponse à la commande",
    "PAYMENT": "Paiement"
  },
  "unknown": "inconnu",
  "updated": "Mise à jour de",
  "user": {
    "avatar": "Avatar",
    "company": "Entreprise",
    "contactTitle": "Titre du contact",
    "department": "Département",
    "email": "Courrier électronique",
    "firstName": "Prénom",
    "language": "Langue",
    "lastName": "Nom de famille",
    "permissions": {
      "changeSubsidiary": "Sociétés de commutation",
      "changeSubsidiaryDescription": "Détermine si l'utilisateur est autorisé à se connecter à des sociétés liées.",
      "permissions": "User permissions",
      "shopAdmin": "Admin",
      "shopAdminDescription": "En tant qu'administrateur, l'utilisateur est autorisé à modifier les droits, les coordonnées, les limites de commande et les approbations des autres employés. En outre, l'utilisateur admin peut inviter de nouveaux collègues directement sur le portail.",
      "submitOrder": "Passer des commandes",
      "submitOrderDescription": "Déterminez si l'utilisateur est autorisé à passer des commandes."
    },
    "phone": "Numéro de téléphone",
    "phoneMobile": "Numéro de téléphone portable",
    "settings": {
      "allowTracking": "Améliorer l'expérience utilisateur",
      "allowTrackingDescription": "Participez au programme d'optimisation pour une meilleure expérience utilisateur.",
      "settings": "Paramètres utilisateur"
    }
  },
  "validDate": "Valable jusqu'au",
  "viewToggle": {
    "ordersApprovals": "Passez à l'aperçu des commandes sur \"Commandes sans approbation\"",
    "ordersGrid": "Passez la vue d'ensemble de la commande à la vue de la colonne",
    "ordersList": "Changer la vue d'ensemble de la commande sur liste",
    "productsCards": "Passez la vue d'ensemble du produit en vue carrelée",
    "productsList": "Communiquez la vue d'ensemble du produit sur liste",
    "quoteActivityChat": "Afficher l'activité pour discuter",
    "quoteActivityHistory": "Vue d'activités de changement de l'histoire"
  },
  "windowTitle": {
    "Collection": "Collection",
    "CompanyOrderLimit": "Approbation de la commande",
    "Login": "Page de connexion",
    "Registration": "Page d'inscription",
    "StartPage": "Page d'accueil"
  },
  "writeSomething": "Écrivez quelque chose...",
  "yes": "Oui",
  "yesterday": "Hier"
}
